import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import '../app.css'
import App from '../App.vue'
import suiteRoutes from '../router/routes/suite'
import { initSentry } from '../lib/sentry'

// Branding
document.title = 'Suite | Codifyo'
const faviconLink = document.getElementById('favicon-link')
if (faviconLink) {
    faviconLink.setAttribute('href', '/favicon.png')
}

const router = createRouter({
    history: createWebHistory(),
    routes: suiteRoutes,
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth) && !localStorage.getItem('apiToken')) {
        next({ name: 'suite_login' })
    } else {
        next()
    }
})

const app = createApp(App)
app.use(router)
initSentry(app, router)
app.mount('#app')
